import { createReducer, on } from '@ngrx/store';
import { HttpError, TransactionStatus } from '@rd/types';
import { UserFlagModel } from '@rd/types/user-flag.model';
import {
  LoadUserFlags,
  LoadUserFlagsFail,
  LoadUserFlagsSuccess,
} from '../actions/user-flags.actions';

export interface UserFlagsState {
  flags: UserFlagModel[] | null;
  state: TransactionStatus;
  error: HttpError | null;
}

const initialState: UserFlagsState = {
  flags: null,
  state: TransactionStatus.INITIAL,
  error: null,
};

export const userFlagsReducer = createReducer(
  initialState,

  on(LoadUserFlags, (state) => {
    return {
      ...state,
      error: null,
      state: TransactionStatus.LOADING,
    };
  }),

  on(LoadUserFlagsSuccess, (state, { payload }) => {
    return {
      flags: payload,
      error: null,
      state: TransactionStatus.SUCCESS,
    };
  }),

  on(LoadUserFlagsFail, (state, { payload }) => {
    return {
      ...state,
      state: TransactionStatus.FAIL,
      error: payload,
    };
  }),
);
